import {time} from '../ladmin/utils'

export let ACTION_PLACEHOLDER = {text: '', value: '', align: 'right', width: '80px', sortable: false}
export let GROUP_HEADERS = [
  {text: '分组名称', value: 'name', align: 'left', placeholder: 'N/A'},
  // {text: '分组描述', value: 'description', align: 'right', placeholder: 'N/A', maxWidth: '14em', tooltip: true},
  {text: '分组类型', value: 'type', align: 'right', placeholder: 'N/A', sortable: true},
  {text: '上次修订', value: 'lastUpdateTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
  {text: '修订人员', value: 'lastEditor', align: 'right', placeholder: 'N/A'}
]
export let ORG_HEADERS = [
  {text: '单位名称', value: 'name', align: 'left', placeholder: 'N/A'},
  // {text: '单位描述', value: 'description', align: 'right', placeholder: 'N/A', maxWidth: '14em', tooltip: true},
  {text: '单位类型', value: 'orgType', align: 'right', placeholder: 'N/A'},
  {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
  {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)}
]
export let GROUP_ACTION_HEADERS = [
  ...GROUP_HEADERS,
  {text: '', value: '', align: 'right', width: '80px', sortable: false}
]
export let ORG_ACTION_HEADERS = [
  ...ORG_HEADERS,
  {text: '', value: '', align: 'right', width: '80px', sortable: false}
]

export const PERMISSION = {
  RESERVATION: {
    PERSON: {
      ADMIN: 'passOrder:person:admin'
    },
    ORG: {
      ADMIN: 'passOrder:org:admin'
    }
  },
  PERSONRESERVATION:{
    ORG:{
      ADMIN:'passObjectOrder:org:admin'
    }
  },
  PARK: {
    CONTROLLER: {
      OPERATION: 'park:iotController:operation',
      DELETE: 'park:iotController:delete',
      UPDATE: 'park:iotController:update',
      DETAIL: 'park:iotController:detail'
    }
  }
}

export default {
  PERMISSION,
  ACTION_PLACEHOLDER,
  GROUP_HEADERS,
  ORG_HEADERS,
  GROUP_ACTION_HEADERS,
  ORG_ACTION_HEADERS
}
